import { render } from "./CompoStep4.vue?vue&type=template&id=88ad78f2"
import script from "./CompoStep4.vue?vue&type=script&lang=js"
export * from "./CompoStep4.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__